import { render, staticRenderFns } from "./OrderDetailSale.vue?vue&type=template&id=33a8175d&scoped=true"
import script from "./OrderDetailSale.vue?vue&type=script&lang=js"
export * from "./OrderDetailSale.vue?vue&type=script&lang=js"
import style1 from "./OrderDetailSale.vue?vue&type=style&index=1&id=33a8175d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8175d",
  null
  
)

export default component.exports